// Pre-defined email recipients for support
export interface EmailRecipient {
  id: string;
  email: string;
  name: string;
  description: string;
  category: "flextrack" | "amazon";
}

export const SUPPORT_RECIPIENTS: EmailRecipient[] = [
  {
    id: "flextrack-support",
    email: "support@flextrack.app", // TODO: Update with actual address
    name: "FlexTrack Support",
    description: "App issues, feature requests, account problems",
    category: "flextrack",
  },
  {
    id: "amazon-flex-support",
    email: "amazonflex-support@amazon.com",
    name: "Amazon Flex Support",
    description: "Block disputes, earnings issues, account concerns",
    category: "amazon",
  },
  {
    id: "amazon-flex-escalation",
    email: "jeff@amazon.com", // Executive escalation
    name: "Amazon Executive (Jeff)",
    description: "Serious issues requiring executive attention",
    category: "amazon",
  },
  {
    id: "amazon-andy-escalation",
    email: "andy@amazon.com", // CEO escalation
    name: "Amazon Executive (Andy)",
    description: "Serious issues requiring executive attention",
    category: "amazon",
  },
  {
    id: "amazon-escalations",
    email: "escalations@amazon.com",
    name: "Amazon Escalations",
    description: "Escalated support issues",
    category: "amazon",
  },
];

// Email addresses to monitor for replies
// Only emails from these addresses will be synced to inbox
export const ALLOWED_SENDERS: string[] = [
  // FlexTrack
  "support@flextrack.app",
  "noreply@flextrack.app",
  // Amazon
  "amazonflex-support@amazon.com",
  "amazonflex-support@logistics.amazon.com",
  "cs-reply@amazon.com",
  "no-reply@amazon.com",
  "flex-support@amazon.com",
  "amazon-flex@amazon.com",
  "noreply@amazon.com",
];

// Helper to check if an email is from an allowed sender
export function isAllowedSender(email: string): boolean {
  const normalizedEmail = email.toLowerCase().trim();
  return ALLOWED_SENDERS.some(
    (allowed) => normalizedEmail === allowed.toLowerCase() ||
    normalizedEmail.endsWith(`<${allowed.toLowerCase()}>`)
  );
}

// Get recipient by ID
export function getRecipientById(id: string): EmailRecipient | undefined {
  return SUPPORT_RECIPIENTS.find((r) => r.id === id);
}

// Get recipient by email address
export function getRecipientByEmail(email: string): EmailRecipient | undefined {
  const normalizedEmail = email.toLowerCase().trim();
  return SUPPORT_RECIPIENTS.find((r) => r.email.toLowerCase() === normalizedEmail);
}

// Get recipients by category
export function getRecipientsByCategory(
  category: "flextrack" | "amazon"
): EmailRecipient[] {
  return SUPPORT_RECIPIENTS.filter((r) => r.category === category);
}
